var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"christmas-calendar-link",attrs:{"href":_vm.link}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('Arrow',{staticClass:"christmas-calendar-link__arrow"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }